import { Reveal, Label } from "./primitives";

const CHAPTERS = [
  {
    n: "I",
    title: "Clarity",
    body: "See your situation from a fresh perspective.",
  },
  {
    n: "II",
    title: "Self-Awareness",
    body: "Understand patterns and emotions that may be influencing you.",
  },
  {
    n: "III",
    title: "Intuitive Guidance",
    body: "Use tarot and intuition to explore possibilities and perspectives.",
  },
  {
    n: "IV",
    title: "Healing",
    body: "Create space to reflect, release and reconnect with yourself.",
  },
  {
    n: "V",
    title: "Empowerment",
    body: "My goal isn't to make you dependent on me for a reading. It's to help you feel more connected to yourself and confident in your own choices.",
  },
];

export const Manifesto = () => (
  <section
    id="philosophy"
    data-testid="manifesto-section"
    className="relative py-24 md:py-32 px-6 md:px-10 bg-[#130C1E]"
  >
    <div className="max-w-[1100px] mx-auto">
      <Reveal>
        <Label>The Philosophy</Label>
        <h2 className="mt-5 font-serif-display font-light text-4xl sm:text-6xl text-[#EAE0D5] tracking-tight leading-tight max-w-3xl">
          An approach rooted in <span className="italic text-[#D4AF37]">intuition</span>,
          intention and deep self-awareness.
        </h2>
      </Reveal>

      <div className="mt-20 relative">
        <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#D4AF37]/40 to-transparent" />
        <div className="space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={0.05}>
              <div
                className={`md:w-1/2 ${
                  i % 2 === 0 ? "md:pr-16" : "md:ml-auto md:pl-16 md:text-right"
                }`}
              >
                <span className="font-serif-display text-6xl text-[#D4AF37]/40 leading-none">
                  {c.n}
                </span>
                <h3 className="mt-4 font-serif-display text-3xl text-[#EAE0D5] font-light">
                  {c.title}
                </h3>
                <p className="mt-4 text-[#A89FA8] leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
